module.exports = __webpack_public_path__ + "static/media/logo-react.e2342b05.svg";


//////////////////
// WEBPACK FOOTER
// ./src/logo-react.svg
// module id = 1555
// module chunks = 0